/* zwim-space-calc.js — the ZWIM space calculator.

   Extracted 17/08/2026 from sections/zwim-how-space.liquid, verbatim apart from the
   root selector, so the PDP "Setup and space" section can render the same calculator
   instead of forking it. Victor on the 12/08 export this came from: "it's done. Use
   this exact one." If the formula changes, it changes here and both pages follow.

   Everything is scoped to the root element it finds — the calculator reads its copy
   and its defaults off data-* attributes on that root, never off the document — so
   two instances on one page would not drive each other.

   THE FORMULA, recalibrated by the designer:
     dMin = round((1.21 * height + 105) / 5) * 5   least floor, 130 cm anchor
     dMax = dMin + 30                               most floor, 90 cm anchor
*/
(function () {
  var roots = document.querySelectorAll('[data-zwim-space-calc]:not([data-zhp-ready])');
  Array.prototype.forEach.call(roots, function (root) {
    root.setAttribute('data-zhp-ready', '1');

    var svg = root.querySelector('.zhp__svg');
    if (!svg) return;

    // ---- projection and helpers, transcribed from the export ----
    var KX = 1.05, KY = 0.336, OX = 330, OY = 300;
    function P(d, l, u) { return [OX + KX * (d - l), OY + KY * (d + l) - 1.05 * u]; }
    function S(d, l, u) { var p = P(d, l, u); return p[0].toFixed(1) + ',' + p[1].toFixed(1); }
    function M(d, l, u) { var p = P(d, l, u); return p[0].toFixed(1) + ' ' + p[1].toFixed(1); }
    function ftin(cm) {
      var ti = cm / 2.54;
      var f = Math.floor(ti / 12), i = Math.round(ti - f * 12);
      if (i === 12) { f += 1; i = 0; }
      return f + "'" + i + '"';
    }
    function r5(v) { return Math.round(v / 5) * 5; }

    function num(attr, fallback) {
      var v = parseInt(root.getAttribute(attr), 10);
      return isNaN(v) ? fallback : v;
    }
    var state = {
      height: num('data-def-height', 178),
      anchorType: root.getAttribute('data-anchor') === 'window' ? 'window' : 'door'
    };

    var copy = {
      rangeTail: root.getAttribute('data-range-tail') || '',
      ok:    [root.getAttribute('data-warn-ok-title'), root.getAttribute('data-warn-ok-body')],
      tall:  [root.getAttribute('data-warn-tall-title'), root.getAttribute('data-warn-tall-body')],
      short: [root.getAttribute('data-warn-short-title'), root.getAttribute('data-warn-short-body')]
    };

    // ---- which computed value lands on which attribute ----
    // Two rows share a key where an element needs two attributes, and several keys
    // match more than one element (the athlete's limbs are drawn twice, dark stroke
    // under light), which is why this uses querySelectorAll.
    var MAP = [
      ['zone', 'points', 'zonePts'],
      ['zoneGrad', 'x1', 'zgX1'], ['zoneGrad', 'y1', 'zgY1'], ['zoneGrad', 'x2', 'zgX2'], ['zoneGrad', 'y2', 'zgY2'],
      ['nearEdge', 'x1', 'nearX0'], ['nearEdge', 'y1', 'nearY0'], ['nearEdge', 'x2', 'nearX1'], ['nearEdge', 'y2', 'nearY1'],
      ['farEdge', 'x1', 'farX0'], ['farEdge', 'y1', 'farY0'], ['farEdge', 'x2', 'farX1'], ['farEdge', 'y2', 'farY1'],
      ['glow', 'cx', 'anchorX'], ['glow', 'cy', 'anchorY'],
      ['strap', 'd', 'strapPath'],
      ['band1', 'd', 'band1'],
      ['band2', 'd', 'band2'],
      ['anchorRing', 'cx', 'anchorX'], ['anchorRing', 'cy', 'anchorY'],
      ['anchorDot', 'cx', 'anchorX'], ['anchorDot', 'cy', 'anchorY'],
      ['shadow', 'points', 'shadowPts'],
      ['benchSideA', 'points', 'benchSideA'],
      ['benchSideB', 'points', 'benchSideB'],
      ['benchTop', 'points', 'benchTop'],
      ['exitUpper', 'd', 'exitUpper'],
      ['exitFore', 'd', 'exitFore'],
      ['thighL', 'd', 'thighL'], ['shankL', 'd', 'shankL'],
      ['thighR', 'd', 'thighR'], ['shankR', 'd', 'shankR'],
      ['torso', 'points', 'torsoPoly'],
      ['catchUpper', 'd', 'catchUpper'],
      ['catchFore', 'd', 'catchFore'],
      ['catchHandPath', 'd', 'catchHandPath'],
      ['cap', 'cx', 'capX'], ['cap', 'cy', 'capY'],
      ['catchHand', 'cx', 'catchHandX'], ['catchHand', 'cy', 'catchHandY'],
      ['exitHand', 'cx', 'exitHandX'], ['exitHand', 'cy', 'exitHandY'],
      ['dimLine', 'x1', 'dimX0'], ['dimLine', 'y1', 'dimY0'], ['dimLine', 'x2', 'dimX1'], ['dimLine', 'y2', 'dimY1'],
      ['dimCap0', 'x1', 'dimC0x0'], ['dimCap0', 'y1', 'dimC0y0'], ['dimCap0', 'x2', 'dimC0x1'], ['dimCap0', 'y2', 'dimC0y1'],
      ['dimCap1', 'x1', 'dimC1x0'], ['dimCap1', 'y1', 'dimC1y0'], ['dimCap1', 'x2', 'dimC1x1'], ['dimCap1', 'y2', 'dimC1y1'],
      ['dimBox', 'x', 'dimBoxX'], ['dimBox', 'y', 'dimBoxY'],
      ['wdLine', 'x1', 'wdX0'], ['wdLine', 'y1', 'wdY0'], ['wdLine', 'x2', 'wdX1'], ['wdLine', 'y2', 'wdY1'],
      ['wdCap0', 'x1', 'wdC0x0'], ['wdCap0', 'y1', 'wdC0y0'], ['wdCap0', 'x2', 'wdC0x1'], ['wdCap0', 'y2', 'wdC0y1'],
      ['wdCap1', 'x1', 'wdC1x0'], ['wdCap1', 'y1', 'wdC1y0'], ['wdCap1', 'x2', 'wdC1x1'], ['wdCap1', 'y2', 'wdC1y1'],
      ['wdText', 'x', 'wdTextX'], ['wdText', 'y', 'wdTextY']
    ];

    // Cache the node lists once. The scene is static markup, so nothing here changes
    // across renders and this keeps a slider drag cheap.
    var NODES = {};
    var i, row;
    for (i = 0; i < MAP.length; i++) {
      row = MAP[i];
      if (!NODES[row[0]]) NODES[row[0]] = root.querySelectorAll('[data-sp="' + row[0] + '"]');
    }
    function txt(key) { return root.querySelector('[data-sp="' + key + '"]'); }
    var elResultCm = txt('resultCm'), elResultImp = txt('resultImp'), elRangeNote = txt('rangeNote');
    var elHeightLabel = txt('heightLabel'), elDimLabel = txt('dimLabel');
    var elWarnTitle = txt('warnTitle'), elWarnBody = txt('warnBody');
    var elHFill = txt('hFill'), elHKnob = txt('hKnob');

    // ---- the calculation, transcribed from the export's renderVals() ----
    function vals() {
      var h = state.height;

      // Calibrated on measured setups at a ~120 cm anchor:
      //   155 cm -> 300, 186 cm -> 340. Slope 1.21 cm of floor per cm of athlete.
      // dMin is the 130 cm-anchor end, dMax the 90 cm-anchor end (30 cm apart);
      // a 120 cm anchor lands a quarter of the way in, which reproduces both measurements.
      var dMin = r5(1.21 * h + 105), dMax = dMin + 30, D = dMin + 8;
      var aH = 110;

      // Body geometry along the floor, centred on lat 85.
      var CL = 85;
      var feetD = D, hipD = D - 0.45 * h, shD = D - 0.80 * h, headD = D - 0.90 * h, handD = D - 1.18 * h;
      var benchD0 = headD + 2, benchD1 = headD + 82;
      // Mid-stroke: near arm extended into the catch, far arm extended back through the exit.
      var catchElbD = (shD + handD) / 2, exitElbD = shD + 0.15 * h, exitHandD = shD + 0.30 * h;
      var kneeD = hipD + 0.13 * h;

      var anchor = P(0, 40, aH);
      var catchHand = P(handD, CL + 20, 38), exitHand = P(exitHandD, CL - 30, 56);

      // Length dimension, drawn on the floor in front of the athlete.
      var d0 = P(0, 198, 0), d1 = P(dMax, 198, 0);
      var dc0a = P(0, 176, 0), dc0b = P(0, 216, 0);
      var dc1a = P(dMax, 176, 0), dc1b = P(dMax, 216, 0);
      var dmid = P(dMax / 2, 198, 0);
      var zg0 = P(0, 85, 0), zg1 = P(dMax, 85, 0);
      var nearA = P(dMin, 20, 0), nearB = P(dMin, 150, 0);
      var farA = P(dMax, 20, 0), farB = P(dMax, 150, 0);

      // Width dimension, just beyond the feet.
      var w0 = P(dMax + 34, 20, 0), w1 = P(dMax + 34, 150, 0);
      var wc0a = P(dMax + 20, 20, 0), wc0b = P(dMax + 48, 20, 0);
      var wc1a = P(dMax + 20, 150, 0), wc1b = P(dMax + 48, 150, 0);
      var wmid = P(dMax + 34, 85, 0);

      return {
        heightLabel: h + ' cm · ' + ftin(h),
        hFill: ((h - 150) / 45 * 100).toFixed(2) + '%',

        resultCm: dMin + '–' + dMax + ' cm',
        resultImp: ftin(dMin) + '–' + ftin(dMax),
        rangeNote: 'The higher you anchor, the closer you sit: ' + dMin + ' cm at a 130 cm anchor, ' + dMax + ' cm at 90 cm. ' + copy.rangeTail,

        warn: h >= 193 ? 'tall' : (h <= 155 ? 'short' : 'ok'),

        anchorX: anchor[0].toFixed(1), anchorY: anchor[1].toFixed(1),
        anchorOrigin: anchor[0].toFixed(1) + 'px ' + anchor[1].toFixed(1) + 'px',
        strapPath: 'M ' + M(0, 40, aH + 16) + ' L ' + M(0, 40, aH),
        band1: 'M ' + M(0, 40, aH) + ' L ' + catchHand[0].toFixed(1) + ' ' + catchHand[1].toFixed(1),
        band2: 'M ' + M(0, 40, aH) + ' L ' + exitHand[0].toFixed(1) + ' ' + exitHand[1].toFixed(1),
        catchHandX: catchHand[0].toFixed(1), catchHandY: catchHand[1].toFixed(1),
        exitHandX: exitHand[0].toFixed(1), exitHandY: exitHand[1].toFixed(1),

        zonePts: [S(0, 20, 0), S(dMax, 20, 0), S(dMax, 150, 0), S(0, 150, 0)].join(' '),
        zgX1: zg0[0].toFixed(1), zgY1: zg0[1].toFixed(1), zgX2: zg1[0].toFixed(1), zgY2: zg1[1].toFixed(1),
        nearX0: nearA[0].toFixed(1), nearY0: nearA[1].toFixed(1), nearX1: nearB[0].toFixed(1), nearY1: nearB[1].toFixed(1),
        farX0: farA[0].toFixed(1), farY0: farA[1].toFixed(1), farX1: farB[0].toFixed(1), farY1: farB[1].toFixed(1),

        benchTop: [S(benchD0, 67.5, 40), S(benchD1, 67.5, 40), S(benchD1, 102.5, 40), S(benchD0, 102.5, 40)].join(' '),
        benchSideA: [S(benchD0, 102.5, 40), S(benchD1, 102.5, 40), S(benchD1, 102.5, 0), S(benchD0, 102.5, 0)].join(' '),
        benchSideB: [S(benchD1, 67.5, 40), S(benchD1, 102.5, 40), S(benchD1, 102.5, 0), S(benchD1, 67.5, 0)].join(' '),

        // V-tapered torso: wide shoulders, narrow hips.
        torsoPoly: [
          S(headD + 10, CL - 7, 55), S(shD - 2, CL - 18, 54), S(hipD, CL - 11, 49),
          S(hipD + 4, CL, 48), S(hipD, CL + 11, 49), S(shD - 2, CL + 18, 54), S(headD + 10, CL + 7, 55)
        ].join(' '),
        exitUpper: 'M ' + M(shD - 2, CL - 18, 54) + ' L ' + M(exitElbD, CL - 24, 56),
        exitFore: 'M ' + M(exitElbD, CL - 24, 56) + ' L ' + M(exitHandD, CL - 30, 56),
        catchUpper: 'M ' + M(shD - 2, CL + 18, 54) + ' L ' + M(catchElbD, CL + 21, 48),
        catchFore: 'M ' + M(catchElbD, CL + 21, 48) + ' L ' + M(handD + 8, CL + 20, 42),
        catchHandPath: 'M ' + M(handD + 8, CL + 20, 42) + ' L ' + M(handD, CL + 20, 38),
        // Flutter kick: equal-length legs, near leg lifted.
        thighL: 'M ' + M(hipD, CL - 11, 49) + ' L ' + M(kneeD, CL - 11, 26),
        shankL: 'M ' + M(kneeD, CL - 11, 26) + ' L ' + M(feetD - 8, CL - 10, 10) + ' L ' + M(feetD, CL - 10, 6),
        thighR: 'M ' + M(hipD, CL + 11, 49) + ' L ' + M(kneeD, CL + 12, 34),
        shankR: 'M ' + M(kneeD, CL + 12, 34) + ' L ' + M(feetD - 8, CL + 11, 18) + ' L ' + M(feetD, CL + 11, 14),
        capX: P(headD, CL, 56)[0].toFixed(1), capY: P(headD, CL, 56)[1].toFixed(1),
        shadowPts: [S(benchD0 - 4, 64, 0), S(benchD1 + 4, 64, 0), S(benchD1 + 4, 106, 0), S(benchD0 - 4, 106, 0)].join(' '),

        dimX0: d0[0].toFixed(1), dimY0: d0[1].toFixed(1), dimX1: d1[0].toFixed(1), dimY1: d1[1].toFixed(1),
        dimC0x0: dc0a[0].toFixed(1), dimC0y0: dc0a[1].toFixed(1), dimC0x1: dc0b[0].toFixed(1), dimC0y1: dc0b[1].toFixed(1),
        dimC1x0: dc1a[0].toFixed(1), dimC1y0: dc1a[1].toFixed(1), dimC1x1: dc1b[0].toFixed(1), dimC1y1: dc1b[1].toFixed(1),
        dimBoxX: (dmid[0] - 152).toFixed(1), dimBoxY: (dmid[1] - 31).toFixed(1),
        dimLabel: dMin + '–' + dMax + ' cm',

        wdX0: w0[0].toFixed(1), wdY0: w0[1].toFixed(1), wdX1: w1[0].toFixed(1), wdY1: w1[1].toFixed(1),
        wdC0x0: wc0a[0].toFixed(1), wdC0y0: wc0a[1].toFixed(1), wdC0x1: wc0b[0].toFixed(1), wdC0y1: wc0b[1].toFixed(1),
        wdC1x0: wc1a[0].toFixed(1), wdC1y0: wc1a[1].toFixed(1), wdC1x1: wc1b[0].toFixed(1), wdC1y1: wc1b[1].toFixed(1),
        wdTextX: wmid[0].toFixed(1), wdTextY: (wmid[1] + 30).toFixed(1)
      };
    }

    function setText(el, s) { if (el) el.textContent = s; }

    function render() {
      var v = vals();
      var n, list, j;

      for (n = 0; n < MAP.length; n++) {
        list = NODES[MAP[n][0]];
        for (j = 0; j < list.length; j++) list[j].setAttribute(MAP[n][1], v[MAP[n][2]]);
      }

      setText(elResultCm, v.resultCm);
      setText(elResultImp, v.resultImp);
      setText(elRangeNote, v.rangeNote);
      setText(elHeightLabel, v.heightLabel);
      setText(elDimLabel, v.dimLabel);
      setText(elWarnTitle, copy[v.warn][0]);
      setText(elWarnBody, copy[v.warn][1]);

      if (elHFill) elHFill.style.width = v.hFill;
      if (elHKnob) elHKnob.style.left = v.hFill;

      var glow = NODES.glow;
      for (j = 0; j < glow.length; j++) glow[j].style.transformOrigin = v.anchorOrigin;

      root.setAttribute('data-warn', v.warn);
      root.setAttribute('data-anchor', state.anchorType);

      var hs = root.querySelector('[data-slider="height"]');
      if (hs) { hs.setAttribute('aria-valuenow', state.height); hs.setAttribute('aria-valuetext', v.heightLabel); }
    }

    // ---- slider. Same clamp-and-round maths as the export's slider(). ----
    function wire(sel, key, min, max) {
      var el = root.querySelector('[data-slider="' + sel + '"]');
      if (!el) return;

      function fromEvent(e) {
        var r = el.getBoundingClientRect();
        if (!r.width) return;
        var p = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        state[key] = Math.round(min + p * (max - min));
        render();
      }

      el.addEventListener('pointerdown', function (e) {
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
        fromEvent(e);
      });
      el.addEventListener('pointermove', function (e) {
        if (el.hasPointerCapture && el.hasPointerCapture(e.pointerId)) fromEvent(e);
      });
      el.addEventListener('keydown', function (e) {
        var step = (e.key === 'ArrowLeft' || e.key === 'ArrowDown') ? -1
                 : ((e.key === 'ArrowRight' || e.key === 'ArrowUp') ? 1 : 0);
        if (!step) return;
        e.preventDefault();
        state[key] = Math.min(max, Math.max(min, state[key] + step));
        render();
      });
    }

    wire('height', 'height', 150, 195);

    Array.prototype.forEach.call(root.querySelectorAll('[data-pill]'), function (btn) {
      btn.addEventListener('click', function () {
        state.anchorType = btn.getAttribute('data-pill');
        render();
      });
    });

    root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-track]') : null;
      if (!t) return;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'zwim_ui', detail: t.getAttribute('data-track') });
      } catch (err) {}
    });

    render();
  });
})();
